/* eslint-disable */
require('./1-st-assessment')
require('./accept-active')
require('./accept-kit')
require('./account')
require('./activity')
require('./add')
require('./archive')
require('./arrow-down-old')
require('./arrow-down')
require('./arrow-left-old')
require('./arrow-right-old')
require('./arrow-up')
require('./assign-kit')
require('./back-arrow')
require('./badge')
require('./bolt')
require('./box')
require('./bulb')
require('./calendar')
require('./calories-filled')
require('./caution')
require('./chat')
require('./check-circle')
require('./check-strong')
require('./check')
require('./chevron-down')
require('./chevron-left')
require('./chevron-right')
require('./chevron-up')
require('./circle-add')
require('./circle-alert')
require('./circle-check')
require('./circle-info')
require('./circle-loading')
require('./clinical-records')
require('./clock')
require('./close-strong')
require('./close')
require('./co_calendar')
require('./copy')
require('./couch-filled')
require('./data')
require('./delete')
require('./delivered-package')
require('./delivered')
require('./dismiss')
require('./dot-separator')
require('./down-arrow')
require('./download')
require('./edit-empty')
require('./edit-outlined')
require('./edit-session')
require('./edit')
require('./envelop')
require('./erase')
require('./exclude')
require('./external-link')
require('./eye')
require('./file')
require('./forbidden')
require('./forms')
require('./funnel')
require('./hand-hold')
require('./heart')
require('./hide-password')
require('./hourglass')
require('./ifu')
require('./image-bold')
require('./image')
require('./info-filled')
require('./info')
require('./instant-message')
require('./institution')
require('./leave-session')
require('./left-arrow')
require('./legal')
require('./lock')
require('./log-out')
require('./login')
require('./logout')
require('./lot')
require('./magic-stars')
require('./mail')
require('./maintenance')
require('./manufacture-date')
require('./manufacturer')
require('./md')
require('./member-profile')
require('./menu')
require('./message')
require('./mind')
require('./minus')
require('./moon')
require('./more-info')
require('./no-app')
require('./no-wifi')
require('./notes')
require('./notifications')
require('./onboarding-profile')
require('./options')
require('./order-by-AZ')
require('./order-by-ZA')
require('./order-kit')
require('./out')
require('./overview')
require('./pen')
require('./phone')
require('./photo-camera')
require('./pin-map')
require('./power-on-off')
require('./prescription-active-past')
require('./prescription-results')
require('./prescription-upcoming')
require('./prescription')
require('./prescriptions')
require('./profile-straight')
require('./profile')
require('./progress-changes')
require('./rate-star-filled')
require('./rate-star')
require('./ref')
require('./referral')
require('./remove')
require('./reorder')
require('./report')
require('./reschedule')
require('./results-charts')
require('./retry')
require('./right-arrow')
require('./save')
require('./schedule')
require('./search')
require('./security')
require('./send')
require('./settings')
require('./shield-cross')
require('./show-password')
require('./skip-forward')
require('./spinner')
require('./star-filled')
require('./star')
require('./support-help')
require('./support')
require('./sword_logo')
require('./sword-arrow-down')
require('./sword-arrow-up')
require('./target-arrow')
require('./therapist')
require('./thumb-down')
require('./timer')
require('./tiny-arrow')
require('./tracking')
require('./transfer')
require('./udi')
require('./ukca')
require('./unlock')
require('./up-trend-arrow')
require('./upload')
require('./user-manual')
require('./user')
require('./video-call-assessment')
require('./video-camera')
require('./video')
require('./voicemail')
require('./warning')
require('./weight')
require('./weights')
require('./world')
